(ns frontend.view.settings2.surveys.question.sub
  (:require
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.view.settings2.surveys.sub :as surveys-sub]
   [re-frame.core :as rf]
   [ui.state.named-values :as named-values]))

(rf/reg-sub
 ::db
 (fn [db _]
   db))

(rf/reg-sub
 ::selected-languages
 (fn [db _]
   (get db ::selected-languages [:ENG])))

(rf/reg-sub
 ::selected-language
 (fn [db [_ languages]]
   (or (get db ::selected-language)
       (some #{:ENG} languages)
       (first languages))))

(rf/reg-sub
 ::survey-question-changes
 (fn [db _]
   (get db ::survey-question-changes)))

(rf/reg-sub
 ::option-list-options
 :<-
 [::db]
 (fn [_db _]
   [{:value 1
     :label "Country"}
    {:value 2
     :label "Currency"}
    {:value 3
     :label "Language"}]))

(rf/reg-sub
 ::saved-survey-question
 (fn [db _]
   (get db ::saved-survey-question)))

(rf/reg-sub
 ::numeric-questions-options
 (fn [db _]
   (->> (get db ::numeric-questions)
        (map (fn [q]
               {:id    (:db/id q)
                :value (:db/id q)
                :label (or (get-in q [:survey-question/label-translations :ENG])
                           (->> q
                                :survey-question/label-translations
                                (map val)
                                (first)))}))
        (sort-by :label)
        (vec))))

(rf/reg-sub
 ::survey-question
 :<-
 [::saved-survey-question]
 :<-
 [::survey-question-changes]
 (fn [[saved changes] _]
   (let [question (merge {}
                         saved
                         changes)]
     question)))

(rf/reg-sub
 ::unsaved-changes
 :<-
 [::saved-survey-question]
 :<-
 [::survey-question-changes]
 (fn [[saved changes] _]
   (->> changes
        (remove (fn [[k v]]
                  (= v (get saved k))))
        (into {})
        (seq))))

(defn unique-external-id?
  [question existing-external-ids]
  (->> (:survey-question/external-ids question)
       (keep (fn [ext-id]
               (let [new-question-battery (:survey-question-ext-id/question-battery ext-id)
                     new-question-ext-id (:survey-question-ext-id/external-id ext-id)
                     new-id (:db/id ext-id)]
                 (->> existing-external-ids
                      (filter (fn [existing-ext-id]
                                (let [question-battery (:survey-question-ext-id/question-battery existing-ext-id)
                                      question-ext-id (:survey-question-ext-id/external-id existing-ext-id)
                                      id (:db/id existing-ext-id)]
                                  (and (= new-question-battery question-battery)
                                       (= new-question-ext-id question-ext-id)
                                       (not= new-id id)))))
                      (first)))))
       (empty?)))

(rf/reg-sub
 ::validate-errors
 :<-
 [::saved-survey-question]
 :<-
 [::survey-question-changes]
 :<-
 [::surveys-sub/tenant-questions-ext-ids]
 (fn [[saved updates tenant-questions-ext-ids]]
   (let [merged (merge saved updates)]
     (->> [(when (cu/blank-value? (some->> merged
                                           :survey-question/label-translations
                                           :ENG))
             (loc/tr :survey-question-english-label-mandatory))
           (when-not (:survey-question/data-type merged)
             (loc/tr :survey-question-data-type-mandatory))
           (when (and (= :data.type/file (:survey-question/data-type merged))
                      (not (boolean? (:survey-question/multi-file? merged))))
             (loc/tr :survey-question-file-multi-mandatory))
           (when (and (= :data.type/file (:survey-question/data-type merged))
                      (empty? (:survey-question/accepted-file-types merged)))
             (loc/tr :survey-question-file-accepted-file-types-mandatory))
           (when-not (unique-external-id? merged tenant-questions-ext-ids)
             (loc/tr :survey-question-external-id-in-use))
           (when (->> (:survey-question/external-ids merged)
                      (some (fn [ext-id]
                              (or (cu/blank-value? (get-in ext-id [:survey-question-ext-id/question-battery :db/id]))
                                  (cu/blank-value? (:survey-question-ext-id/external-id ext-id))))))
             (loc/tr :survey-question-external-id-incomplete))]
          (remove nil?)
          (seq)))))

(rf/reg-sub
 ::lang-select-open?
 (fn [db _]
   (get-in db [::lang-select-open?])))

;; Resolved on demand rather than from @session/entities: :entity.type/named-value
;; is not bulk-synced on the new grid, so the session read returned nothing and
;; this dropdown was empty. See ui.state.named-values. Callers must dispatch
;; ::named-values/ensure-loaded for the attribute.
(rf/reg-sub
 ::question-battery-options
 (fn [_ _]
   (rf/subscribe [::named-values/options :survey-question-ext-id/question-battery]))
 (fn [options _]
   options))
